module.exports = __webpack_public_path__ + "4a7b1fd39309e6b35b458f09a677fa58.webp";